import './sections.css'

const PHASES = [
  {
    icon: '🚀',
    label: 'Phase 1: Pilot (Days 1–30)',
    items: [
      'Select 2–3 high-volume roles',
      'Configure interview templates',
      'Run parallel process for validation',
      'Prove 50%+ time savings',
    ],
  },
  {
    icon: '⚙️',
    label: 'Phase 2: Optimize (Days 31–60)',
    items: [
      'Analyze pilot results',
      'Refine questions and scoring',
      'Integrate with existing systems',
      'Expand to additional roles',
    ],
  },
  {
    icon: '📈',
    label: 'Phase 3: Scale (Days 61–90)',
    items: [
      'Organization-wide rollout',
      'Add SmartDevelop, SmartAssess, SmartAssist',
      'Train team on full platform',
      'Establish success metrics dashboard',
    ],
  },
]

export default function PilotSection() {
  return (
    <section className="pilot-section section">
      <div className="container">
        <p className="section-eyebrow">IMPLEMENTATION</p>
        <h2 className="section-title">From Pilot to Platform in 90 Days</h2>
        <div className="pilot-grid">
          {PHASES.map(p => (
            <div key={p.label} className="pilot-card">
              <div className="pilot-icon">{p.icon}</div>
              <h3 className="pilot-phase-label">{p.label}</h3>
              <ul className="pilot-list">
                {p.items.map(item => (
                  <li key={item}>✓ {item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="pilot-callout">Most customers see ROI before full deployment is complete.</p>
      </div>
    </section>
  )
}
